"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var angular2_indexeddb_1 = require("./angular2-indexeddb");
exports.AngularIndexedDB = angular2_indexeddb_1.AngularIndexedDB;
